import React, { createRef } from "react";
import PropTypes from "prop-types";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import 'swiper/components/pagination/pagination.less'
import utils from "../../utils/utils";
import Request from "../../utils/request";
import { uploadPcTrack } from "shihuo-lib/dist/shihuo-lib";
import QRCode from 'qrcode.react';
import "./style.less";

//链接商品预览
const mallTypes = [
  {
    key:0,
    mall:'得物',
    url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/dewu_preview',
  },
  {
    key:1,
    mall:'抖音',
    url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/douyin_preview',
  },
  {
    key:2,
    mall:'拼多多',
    url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/pdd_preview',
  },
  {
    key:3,
    mall:'通用',
    url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/common_preview',
  }
]

const channelShowType = ["识货状态","关联商品","商品状态","同步时间","店铺ID","店铺名称","店铺状态","识货固定位","营销文案","操作选项"]
class PipelineGoodsInfoPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgActiveIndex: 0,
      tabIndex: 0,
      selectedId: [],
      skuDataList:[],
      selectedValue:[],
      goodsData: {},
      lastModiefied:{name:'',value:''},
      _skuDataList:[],
      NODATA:false,
      loading:true,
      channelList:[],
      attrRelatedList:[],
      attrToUniqueIdMap: {}, // 新增属性
    };
    this.swiperRef = createRef();
    this.height = 620;
    this.mallType = mallTypes[3]
    this.hasUserScrolledX = false;
    this.hasUserScrolledY = false;
    this._isUserInteracting = false;
    this._uiTimer = null;
    this._lastScroll = {
      x: 0,
      y: 0,
    };
    this._hScrollEl = null;
    this._lastHScrollX = 0;
    window.addEventListener("message", ({ data }) => {
      if (data.type === 'showPreviewData' && data.data) {
        //FIXME 接收父组件发送的数据，渲染页面
        this.dealData(data.data)
      }
    }, false);
    //FIXME 通知父组件，该组件已加载
    window.parent.postMessage({type: 'sendMsgToPreviewParent'}, 'https://backstage.shihuo.cn');  
    this._onUserInteract = () => {
      this._isUserInteracting = true;
      this._uiTimer && clearTimeout(this._uiTimer);
      this._uiTimer = setTimeout(() => {
        this._isUserInteracting = false;
      }, 200);
    };
    this._handleScroll = () => {
      const de = document.documentElement;
      const b = document.body;
      const scrollTop = (de && de.scrollTop) || (b && b.scrollTop) || 0;
      const scrollLeft = (de && de.scrollLeft) || (b && b.scrollLeft) || 0;
      const dx = scrollLeft - (this._lastScroll && this._lastScroll.x || 0);
      const dy = scrollTop - (this._lastScroll && this._lastScroll.y || 0);
      const manualX = !!this._isUserInteracting && Math.abs(dx) > 0;
      const manualY = !!this._isUserInteracting && Math.abs(dy) > 0;
      this._lastScroll = { x: scrollLeft, y: scrollTop };
      // console.log('manualX',manualX,manualY, this._lastScroll, scrollLeft, scrollTop)
      // 若没有新方向被检测到，直接返回（避免重复发送）
      const firstX = (!this.hasUserScrolledX && manualX);
      const firstY = (!this.hasUserScrolledY && manualY);
      if (!firstX && !firstY) return;
      // 更新方向标记
      if (firstX) this.hasUserScrolledX = true;
      if (firstY) this.hasUserScrolledY = true;
      // 仅在首次检测到对应方向时发送一次消息
      const payload = {
        type: 'previewIframeScroll',
        scrollTop,
        scrollLeft,
        at: Date.now(),
        manualX: !!firstX,
        manualY: !!firstY,
      };
      this.uploadClickTrack({
        id: 'pageHorizontalScroll',
      })
      window.parent && window.parent.postMessage(payload, '*');
      // 若两个方向均已检测到，移除 window 的滚动监听，避免额外开销
      if (this.hasUserScrolledX && this.hasUserScrolledY) {
        document.querySelector('body').removeEventListener('scroll', this._handleScroll);
      }
    };
    this._handleHorizContainerScroll = () => {
      if (!this._hScrollEl) return;
      const x = this._hScrollEl.scrollLeft || 0;
      const dx = x - (this._lastHScrollX || 0);
      const manualX = !!this._isUserInteracting && Math.abs(dx) > 0;
      this._lastHScrollX = x;
      // 只在首次横向手动滚动时发送一次
      if (!manualX || this.hasUserScrolledX) return;
      this.hasUserScrolledX = true;
      const de = document.documentElement;
      const b = document.body;
      const payload = {
        type: 'previewIframeScroll',
        scrollTop: (de && de.scrollTop) || (b && b.scrollTop) || 0,
        scrollLeft: (de && de.scrollLeft) || (b && b.scrollLeft) || 0,
        at: Date.now(),
        manualX: true,
        manualY: false,
        container: 'bottom-img-ul',
        containerScrollLeft: x,
      };
      this.uploadClickTrack({
        id: 'pageHorizontalScroll',
      })
      window.parent && window.parent.postMessage(payload, '*');
      // 横向首次已上报，可移除容器滚动监听
      this._hScrollEl && this._hScrollEl.removeEventListener('scroll', this._handleHorizContainerScroll);
      // 如果纵向也已检测到，则移除 window 滚动监听
      if (this.hasUserScrolledY) {
        document.querySelector('body').removeEventListener('scroll', this._handleScroll);
      }
    };

  }

  componentDidMount() {
    const arrObj = window.location.href.split("?");
    let params = {}
    let type = mallTypes[3]
    if (arrObj.length > 1) {
      const arrPara = arrObj[1].split("&");
      let arr;
      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
        if (arr != null && arr[0]) {
          params[arr[0]] = arr[1]
        }
      }
      this.operate_from = decodeURIComponent((params && params.operate_from) || '');
      this.platform = decodeURIComponent((params && params.platform) || '');
      this.username = decodeURIComponent((params && params.username) || '');
      this.fromPreview = (params && params.fromPreview) || ''
      const previewDataFlag = (params && params.previewDataFlag) || false
      this.url = (params && params.url) || '';
      if(!previewDataFlag){
        let _url = decodeURIComponent(this.url)
        if(_url.indexOf('m.poizon.com') != -1 || _url.indexOf('m.dewu.com') != -1){
          type = mallTypes[0]
        }else if (_url.indexOf('mobile.yangkeduo.com') != -1 ){
          type.mall = mallTypes[2].mall
        }else if(_url.indexOf('haohuo.jinritemai.com') != -1 ){
          type.mall = mallTypes[1].mall
        }else if(_url.indexOf('item.taobao.com/item.htm') != -1 ){
          type.mall = '淘宝'
        }else if(_url.indexOf('detail.tmall') != -1 ){
          type.mall = '天猫'
        }else if(_url.indexOf('item.jd') != -1 ){
          type.mall = '京东'
        }else if(_url.indexOf('detail.vip.com/detail') != -1 ){
          type.mall = '唯品会'
        }else if(_url.indexOf('yunmall.shihuo.cn') != -1 ){
          type.mall = '云mall'
        }else if(_url.indexOf('app.kwaixiaodian.com') != -1 ){
          type.mall = '快手'
        }else if(_url.indexOf('www.95fenapp.com') != -1 ){
          type.mall = '95分'
        }else if(_url.indexOf('www.goofish.com') != -1 ){
          type.mall = '闲鱼'
        }
        this.mallType = type
        this.getData(type)
      }
      if(params && params.hiddenOverflowY == 1){
        document.querySelector('html').style.overflowY = 'hidden'
      }
    } else {
      utils.toast('渠道链接无效')
    }
    this.changeHeightInterval && clearInterval(this.changeHeightInterval)
    this.changeHeightInterval = null
    this.changeHeightInterval = setInterval(()=>{
      if(document.querySelector('.pipeline-goodsInfoPreview').clientHeight){
        const height = document.querySelector('.pipeline-goodsInfoPreview').clientHeight
        if(height !== this.height){
          this.height = height;
          console.log('====',height);
          window.parent.postMessage({
            type: 'previewGoodsChangeHeight',
            height,
          }, '*');
        }
      }
    },1000)
    // 绑定 window 滚动与用户交互监听
    document.querySelector('body').addEventListener('scroll', this._handleScroll, { passive: true });
    ['wheel','touchstart','mousedown','keydown'].forEach(evt => {
      document.querySelector('body').addEventListener(evt, this._onUserInteract, { passive: true });
    });
  }
  componentWillUnmount(){
    this.changeHeightInterval && clearInterval(this.changeHeightInterval)
    this._uiTimer && clearTimeout(this._uiTimer);
    // 清理 window 监听
    document.querySelector('body').removeEventListener('scroll', this._handleScroll);
    ['wheel','touchstart','mousedown','keydown'].forEach(evt => {
      document.querySelector('body').removeEventListener(evt, this._onUserInteract);
    });
  }

  async getData(mallType = {}) {
    
    const params = { mall: mallType.mall, project_name: 'goods-detail', project_key: decodeURIComponent(this.url) }
    try {
      const res = await Request({
        url: mallType.url,
        method: "get",
        params,
      })
      if (res.data.code === 0) {
        const data = res.data.data;
        this.dealData(data)
      } else {
        // utils.toast(res.data.msg)
        this.setState({loading: false, NODATA: true})
      }
      this.uploadLog(mallType,res.data.code)
    } catch (e) {
    }
  }
  getMallType(){
    let type = {}
    let _url = decodeURIComponent(this.url)
    console.log('=====url=====',_url)
    if(_url.indexOf('m.poizon.com') != -1 || _url.indexOf('m.dewu.com') != -1){
      type = mallTypes[0]
    }else if (_url.indexOf('mobile.yangkeduo.com') != -1 ){
      type.mall = mallTypes[2].mall
    }else if(_url.indexOf('haohuo.jinritemai.com') != -1 ){
      type.mall = mallTypes[1].mall
    }else if(_url.indexOf('item.taobao.com/item.htm') != -1 ){
      type.mall = '淘宝'
    }else if(_url.indexOf('detail.tmall') != -1 ){
      type.mall = '天猫'
    }else if(_url.indexOf('item.jd') != -1 ){
      type.mall = '京东'
    }else if(_url.indexOf('detail.vip.com/detail') != -1 ){
      type.mall = '唯品会'
    }else if(_url.indexOf('yunmall.shihuo.cn') != -1 ){
      type.mall = '云mall'
    }else if(_url.indexOf('app.kwaixiaodian.com') != -1 ){
      type.mall = '快手'
    }else if(_url.indexOf('www.95fenapp.com') != -1 ){
      type.mall = '95分'
    }else if(_url.indexOf('www.goofish.com') != -1 ){
      type.mall = '闲鱼'
    }
    this.mallType = type
  }
  async getChannelData() {

    const params = { url: decodeURIComponent(this.url) }
    try {
      const res = await Request({
        url: `//sh-gateway.shihuo.cn/v4/services/sh-supplierextendadmin/supplier/check/rule`,
        method: "get",
        params,
      })
      this.getMallType()
      if(this.mallType.mall != '淘宝' && this.mallType.mall != '天猫'){
        this.getChannelCheckListData()
      }
      if (res.data.code == 0) {
        const data = res.data.data || [];
        let statusRule = null
        this.attrRule = null
        data.map(item=>{
          if(item.report.url.indexOf('status') != -1){
            statusRule = {rule_id:item.rule_id,url:item.report.url,store:item.store}
          }else if(item.report.url.indexOf('attr') != -1 && !this.attrRule){
            this.attrRule = {rule_id:item.rule_id,url:item.report.url,store:item.store}
          }
        })
        if(statusRule){
          this.getChannelListData(statusRule)
        }
        if(this.attrRule){
          this.getAttrData()
        }
      }
    } catch (e) {
    }
  }
  async getChannelCheckListData(){
    const unique_id = decodeURIComponent(this.url)
    const params = { 
      supplier_urls: [unique_id],
      supplier_store: this.mallType.mall, 
    }
    try {
      const res = await Request({
        url: `//sh-gateway.shihuo.cn/v4/services/sh-supplierextendadmin/supplier/check`,
        method: "post",
        data: params,
      })
      if (res.data.code == 0) {
        const data = res.data.data || {};
        console.log('===channelList===',data.detail[unique_id])
        this.setState({channelList: data.detail[unique_id] || []})
      }
    } catch (e) {
    }
  }
  async getChannelListData(statusRule){
    const unique_id = `extracted0_${statusRule.rule_id}`
    const params = { 
      data:[{
        shop_id: "",
        shop_id_href: "",
        shop_name: "",
        supplier_url: decodeURIComponent(this.url),
        unique_id,
      }],
      rule_id:statusRule.rule_id, 
      store: statusRule.store, 
      need_record: 0 
    }
    try {
      const res = await Request({
        url: statusRule.url,
        method: "post",
        data: params,
      })
      if (res.data.code == 0) {
        const data = res.data.data || {};
        console.log('===channelList===',data.detail[unique_id])
        this.setState({channelList: data.detail[unique_id] || []})
        
      }
    } catch (e) {
    }
  }
  async getAttrData(){
    const { _skuDataList } = this.state
    console.log('===_skuDataList==',_skuDataList)
    const list = []
    let index = 0
    // 创建一个映射表，记录每个属性值对应的 unique_id
    const attrToUniqueIdMap = {}
    
    _skuDataList.map(item=>{
      item.list.map(i=>{
        if(!list.find(e=>e.attr_name == i.value)){
          const uniqueId = `extracted${index}_${this.attrRule.rule_id}`
          list.push({
            attr_name: i.value,
            supplier_url: decodeURIComponent(this.url),
            unique_id: uniqueId,
          })
          // 保存属性值和 unique_id 的映射关系
          attrToUniqueIdMap[i.value] = uniqueId
          ++index
        }
      })
    })
    const params = { 
      data: list,
      rule_id: this.attrRule.rule_id, 
      store: this.attrRule.store, 
      need_record: 0
    }
    if(this.supplier_id){
      params.supplier_id = this.supplier_id
    }
    try {
      const res = await Request({
        url: this.attrRule.url,
        method: "post",
        data: params,
      })
      if (res.data.code == 0) {
        const data = res.data.data;
        // 保存 attrToUniqueIdMap 到 state，以便在渲染时使用
        this.setState({
          attrRelatedList: data.detail,
          attrToUniqueIdMap: attrToUniqueIdMap
        })
      }
    } catch (e) {
    }
  }
  dealData = (data)=> {
    if (data.skus && data.skus.length > 0) {
      const attr = data.skus[0].attr || []
      let nameArr = []
      attr.map(item => {
        nameArr.push(item.name)
      })
      data.skus = data.skus.map(item => {
        return {
          ...item,
          attr: item.attr ? item.attr.sort((a,b) => { return nameArr.indexOf(a.name) - nameArr.indexOf(b.name)}) : []
        }
      })
    }else{
      this.setState({NODATA:true})
      return 
    }
    const { skus = [] } = data || {};
    let skuTitleList = []
    if (skus && skus.length > 0) {
      const attr = skus[0].attr || []
      attr.map(item => {
        skuTitleList.push({ name: item.name })
      })
    }else{
      this.setState({NODATA:true})
      return
    }
    skuTitleList && skuTitleList.map((item, index) => {
      const { name = '' } = item;
      let attrObj = {}
      skus && skus.map((skuItem) => {
        const { attr = [] } = skuItem
        attr && attr.map((attrItem) => {
          if (attrItem.name == name) {
            skus && skus.map((sItem) => {
              const { sku_id } = sItem
              const fIndex = sItem.attr ? sItem.attr.findIndex((aItem) => aItem.propertyValueId == attrItem.propertyValueId) : -1;
              if (fIndex == 0 && sItem.attr && sItem.attr.length == 1) {
                attrObj[attrItem.propertyValueId] = { ...attrItem, sku_id }
              } else if (fIndex == 0 && sItem.attr && sItem.attr.length > 1) {
                attrObj[attrItem.propertyValueId + '-' + sItem.attr[1].propertyValueId] = { ...attrItem, [sItem.attr[1].propertyValueId]: sItem.attr[1], sku_id }
              } else if (fIndex == 1 && sItem.attr && sItem.attr.length > 0) {
                attrObj[sItem.attr[0].propertyValueId + '-' + attrItem.propertyValueId] = { ...attrItem, [sItem.attr[0].propertyValueId]: sItem.attr[0], sku_id }
              }
            })

          }
        })
      })
      skuTitleList[index].attrObj = attrObj
    })
    let skuDataList = [];
    let selectedValue = [];
    if (skus && skus.length > 0) {
      const attr = skus[0].attr || []
      attr.map(item => {
        skuDataList.push({ name: item.name, list:[] })
        selectedValue.push({ name: item.name, value:'' })
      })
      skus.map( sku => {
        sku.attr && sku.attr.map((item,index) => {
          const ind = skuDataList.findIndex(e => e.name == item.name)
          if(ind != -1){
            skuDataList[ind].list.push({...item,image:sku.image})
          }
        })
      })
    }

    let selectedId = ['','','']
    if (skus && skus.length > 0 && skus[0].attr && skus[0].attr.length == 1) {
      selectedId = [skus[0].attr[0].propertyValueId, '', skus[0].sku_id]
    } else if (skus && skus.length > 0 && skus[0].attr && skus[0].attr.length == 2) {
      selectedId = [skus[0].attr[0].propertyValueId, skus[0].attr[1].propertyValueId, skus[0].sku_id]
    }
    // selectedId[0] = ''
    this.setState({ goodsData: data || {}, selectedId, skuTitleList, skuDataList, _skuDataList:skuDataList, selectedValue, loading:false }, () => {
      // 轮播组件初始化
      this.swiper = new Swiper(this.swiperRef.current, {
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: false,
        loop: false
      });
      this.swiper.on('slideChange', () => {
        this.handleSlideChange(this.swiper)
      });
      this.handleSlideChange({ realIndex: 0 });
      if(this.fromPreview == 1){
        //需要切换并滚动到商详
        const children = document.querySelector('.tab-container').children || []
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if(child.innerText == '商详图片'){
            this.setState({
              tabIndex: i
            },()=>{
              setTimeout(()=>{
                window.scrollTo(0,document.querySelector('.tab-container').offsetTop)
              },300)
            })
          }
        }
      }
      this.getChannelData()
    })
  }

  uploadClickTrack(pti = {}){
    uploadPcTrack({
      pti,
      urlinfo: '',
      channel: 'H5Preview',
    })
  }

  uploadLog=(mallType,code)=>{
    const userInfo = window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : {}
    console.log('userInfo',userInfo)
      typeof window !== 'undefined' && uploadPcTrack({
        pti: {
          id: 'H5preview_plugin',
          biz: JSON.stringify({
            channel_url: decodeURIComponent(this.url),
            operator_name: this.username,
            store: mallType && mallType.mall,
            platform: this.platform,
            preview_result: this.state.NODATA ? '暂无数据' : code === 0 ? '成功': '失败',
            operate_from: this.operate_from
          }),
        },
        urlinfo: '',
        channel: '',
        client_code: userInfo && userInfo.uid,
      });
  }
  handleSlideChange = (swiper) => {
    const imgActiveIndex = swiper.realIndex;
    const that = this;
    this.setState({
      imgActiveIndex,
    }, () => {
      const view = document.querySelector(".bottom-img-ul");
      view && that.scroll(view.scrollLeft, (imgActiveIndex - 1) * 120 / 2)
    });
  }
  scrollToX(isAdd = false) {
    const view = document.querySelector(".bottom-img-ul");
    const x = isAdd ? view.scrollLeft + 104 : view.scrollLeft - 104
    view && this.scroll(view.scrollLeft, x)
  }
  scroll(currentY, targetY) {
    // 计算需要移动的距离
    let needScrollTop = targetY - currentY
    let _currentY = currentY
    setTimeout(() => {
      // 一次调用滑动帧数，每次调用会不一样
      const dist = Math.ceil(needScrollTop / 10)
      _currentY += dist
      document.querySelector(".bottom-img-ul").scrollTo(_currentY, 0);
      // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
      if (needScrollTop > 10 || needScrollTop < -10) {
        this.scroll(_currentY, targetY)
      }
    }, 1)
  }
  handleImgItemClick = (item, index) => {
    console.log('handleImgItemClick===',item)
    this.uploadClickTrack({
      id: 'previewGoodsBigImg',
      biz: JSON.stringify({ url: decodeURIComponent(item) })
    })
    window.parent.postMessage({
      type: 'previewGoodsBigImg',
      url: item,
    }, '*');
  }
  handleItemClick = (item, index) => {
    this.setState({
      imgActiveIndex: index,
    }, () => {
      this.uploadClickTrack({
        id: 'imgSwiper',
        biz: JSON.stringify({ index })
      })
      this.swiper && this.swiper.slideTo(index, 300, false)
    });

  }
  renderGoodsImgList() {
    const { imgActiveIndex } = this.state
    const { goodsData = {}, selectedId = [], selectedValue } = this.state;
    const { skus = [] } = goodsData || {}
    if (!skus || skus.length == 0) return null;
    const sku_id = selectedId[2]
    let index = selectedValue ? selectedValue.findIndex(e => e.name == '颜色') : -1
    index = index == -1 ? 0 : index
    const skuValue = selectedValue && selectedValue[index] ? selectedValue[index].value : ''
    const i = skus.findIndex((item) => item.attr && item.attr.findIndex(e => e.value == skuValue)!= -1)
    // const i = skus.findIndex((item) => item.sku_id == sku_id)

    let spu_images = []
    if (i > -1) {
      spu_images = skus[i].image || []
    }
    if(skuValue == ''){
      spu_images = goodsData.spu_images || []
    }
    if(!spu_images || spu_images.length == 0){
      spu_images = goodsData.spu_images || []
    }
    return <div>
      <div className="swiper-container" ref={this.swiperRef} style={{width: 300,height: 300}}>
        <div className="swiper-wrapper">
          {spu_images && spu_images.map((item, index) => {
            return (
              <div className="swiper-slide" onClick={this.handleImgItemClick.bind(this, item, index)} key={"img_" + index}>
                <div className="img-item" style={{maxWidth: 300,maxHeight: 300}}>
                  <img
                    width="100%"
                    threshold={500}
                    height="100%"
                    src={utils.formatImgUrl(item, this.props.webpSupport)}
                    effect="opacity"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="bottom-img-container" >
        <div className="left-icon-bg" onClick={() => {
          this.scrollToX(false)
        }}>
          <div className="left-icon" />
        </div>
        <ul className="bottom-img-ul">

          {spu_images && spu_images.map((item, index) => {
            const isSelected = imgActiveIndex == index;
            return <li key={index}
              className="bottom-img-li-parent"
              style={{
                marginLeft: index == 0 ? '9px' : '0px',
                marginRight: index == spu_images.length - 1 ? '15px' : '8px',
              }}
              onClick={() => {
                this.handleItemClick(item, index)
              }} >
              <div
                className={isSelected ? "bottom-img-li-float" : 'bottom-img-li'}
                style={{
                  marginLeft: '5px'
                }}>
                <img
                  width="100%"
                  threshold={500}
                  height="100%"
                  src={utils.formatImgUrl(item, this.props.webpSupport)}
                  effect="opacity"
                />
              </div>
            </li>
          })}
          <div style={{ width: 1 }} />
        </ul>
        <div className="right-icon-bg" onClick={() => {
          this.scrollToX(true)
        }}>
          <div className="right-icon" />
        </div>
      </div>
    </div>
  }
  renderTitle() {
    const { goodsData = {} } = this.state;
    const { title = '', mall = '', onTime } = goodsData || {}
    return <div className="top-title-container">
      {mall ? <span className="iconTxt">{mall}</span> : null}
      {onTime == 1 ? <span className="iconGreenTxt">实时</span> : null}
      <span className="title">{title}</span>
    </div>
  }
  renderSKUNum() {
    const { goodsData = {}, selectedId = [], selectedValue } = this.state;
    const { skus = [], sellCount } = goodsData || {}
    let v = null
    if (!skus || skus.length == 0){
    }else{
      // const sku_id = selectedId[2]
      // const item = skus.find((item) => item.sku_id == sku_id)
      const index = selectedValue.findIndex(e => e.name == '颜色')
      const skuValue = selectedValue[0].value || ''
      const i = skus.findIndex((item) => item.attr.findIndex(e => e.value == skuValue)!= -1)
      const item  = skus[i];
      if (!item){
        v = null
      }else{
        v = <div className="info-view">
        <div className="info">库存：{item.status == 1 ? '有' : '--'}</div>
        <div className="info">销量：{item.sale_count}</div>
        <div className="info">评价数：{item.appraisal}</div>
      </div>
      }
    }
    return <div className="top-sku-num-container">
      {v}
      <div className="total">总销量：{sellCount}</div>
    </div>
  }
  renderDescInfo() {
    const { goodsData = {}, selectedId = [], selectedValue } = this.state;
    const { skus = [] } = goodsData || {}
    if (!skus || skus.length == 0) return null;
    // const sku_id = selectedId[2]
    // const item = skus.find((item) => item.sku_id == sku_id)
    const index = selectedValue.findIndex(e => e.name == '颜色')
    const skuValue = selectedValue[0].value || ''
    const i = skus.findIndex((item) => item.attr.findIndex(e => e.value == skuValue)!= -1)
    const item  = skus[i];
    if (!item) return null;
    return <div className="top-desc-container">
      <span className="title">
        {item.trade_info || ''}
      </span>
    </div>
  }
  selectItem = (idStr, i = 0, sku_id) => {
    const { goodsData = {}, skuTitleList = [], selectedId = [] } = this.state;
    let imgActiveIndex = this.state.imgActiveIndex;
    // const { skus = [] } = goodsData || {}
    // const lastId = selectedId[i]
    const ids = idStr.split('-') || []
    // const item = skuTitleList[i == 0 ? 1 : 0] || {}
    // const { attrObj = {} } = item || {}
    // let attrStrList = Object.keys(attrObj) || []
    // const index = attrStrList.findIndex((aItem) => aItem.split('-')[i == 0 ? 1 : 0] == ids[i])
    // if (index == -1) {
    //   return utils.toast('请选择其他选项')
    // }
    if(i == 0 && selectedId[i] == ids[i]){
      selectedId[i] = ''
    }else{
      selectedId[i] = ids[i]
      imgActiveIndex = 0;
    }
    selectedId[2] = sku_id
    // selectedId[0] = ''
    this.setState({ selectedId, imgActiveIndex }, () => {
      this.swiper && this.swiper.slideTo(0, 300, false)
      this.uploadClickTrack({
        id: 'itemSelect',
        biz: JSON.stringify({ selectedId, index: imgActiveIndex })
      })
    })
  }
  deRepeat(list){
    let resList = [];
    let map = []
    list.map(e => {
      if(!map.includes(e.value)){
        resList.push(e);
        map.push(e.value)
      }
    })
    return resList
  }

  renderSKUList() {
    const { skuTitleList = [], goodsData = {}, selectedId } = this.state;
    const { skus = [] } = goodsData || {}
    return <div className="top-sku-list-container">
      {skuTitleList && skuTitleList.map((item, index) => {
        const { name = '', attrObj = {} } = item;
        const list = Object.keys(attrObj) || []
        console.log('--list--', list,skuTitleList);
        return <div key={index} className="item-container">
          <div className="title">{name + "："}</div>
          <div className="list">
            {list && list.map((cItem, cIndex) => {
              const id0 = cItem.split('-')[0]
              const id1 = cItem.split('-')[1]
              if (index == 0 && this.state.selectedId[1] != '' && id1 != this.state.selectedId[1]) return null
              if (index == 1 && id0 != this.state.selectedId[0]) return null
              const childItem = attrObj[cItem]
              let isSelected = false
              if (index == 0) {
                isSelected = this.state.selectedId[0] == id0
              } else if (index == 1) {
                isSelected = this.state.selectedId[1] == id1
              }
              const i = skus.findIndex((item) => item.sku_id == childItem.sku_id)
              let spu_image = ''
              if (skuTitleList.length > 1 && index == 0 && i > -1 && skus[i].image && skus[i].image.length > 0) {
                spu_image = skus[i].image[0] || ''
              }
              return <div key={index + "_child_" + cIndex} id='listItem' className={isSelected ? "list-item-selected" : "list-item"} style={{ minHeight: spu_image ? '26px' : '18px' }} onClick={() => {
                this.selectItem(cItem, index, childItem.sku_id)
              }}>
                {spu_image &&
                  <div className="img">
                    <img
                      // width="100%"
                      threshold={500}
                      // height="100%"
                      style={{width:'0.53rem',height:'0.53rem',position:'relative',top:'-0.54rem'}}
                      src={utils.formatImgUrl(spu_image, this.props.webpSupport)}
                      effect="opacity"
                    />
                  </div>}
                <span className="content">{childItem.value}</span>
              </div>
            })}
          </div>
        </div>
      })}
    </div>
  }
  renderSKUListNew(){
    const { skuDataList = [], goodsData = {}, selectedValue, _skuDataList, attrRelatedList, attrToUniqueIdMap } = this.state;
    const { skus = [] } = goodsData || {}
    
    return <div className="top-sku-list-container">
      {_skuDataList.map((attrs,index) => {
        const attrList = this.deRepeat(attrs.list)
        // console.log("attrList",attrList)
        return (<div key={index} className="item-container">
          <div className="title">{attrs.name + "："}</div>
          <div className="list">
            {
              attrList.map((cItem,cIndex) => {
                const image = cItem.name == '颜色' && cItem.image ? cItem.image[0] : null
                const isSelect =  (selectedValue.find(e=> e.value == cItem.value)) ? true : false;
                const hasRelated = attrRelatedList && attrToUniqueIdMap && 
                  attrToUniqueIdMap[cItem.value] && 
                  attrRelatedList[attrToUniqueIdMap[cItem.value]];
                
                return (
                  <div 
                    key={index + "_child_" + cIndex} 
                    id='listItem'
                    className={isSelect ? "list-item-selected" : "list-item"} 
                    onClick={(e) => {
                      e.stopPropagation(); 
                      this.filterItem(cItem, cIndex)
                    }}
                  >
                    <div className="item-main-content">
                      {image &&
                        <div className="img">
                          <img
                            threshold={500}
                            // style={{width:'0.5rem',height:'0.5rem',position:'relative',top:'-0.55rem'}}
                            src={utils.formatImgUrl(image, this.props.webpSupport)}
                            effect="opacity"
                          />
                        </div>
                      }
                      <span className="content">{cItem.value}</span>
                    </div>
                    
                    {hasRelated && 
                      <div className="item-related-content">
                        <div 
                          className="related" 
                          onClick={(e)=>{ 
                            e.stopPropagation(); 
                            if(attrRelatedList[attrToUniqueIdMap[cItem.value]].href) window.open(attrRelatedList[attrToUniqueIdMap[cItem.value]].href, '_blank')
                          }}
                          dangerouslySetInnerHTML={{ 
                            __html: attrRelatedList[attrToUniqueIdMap[cItem.value]].html_status 
                          }}
                        ></div>
                      </div>
                    }
                  </div>
                )
              })
            }
          </div>
        </div>)
      })}
    </div>
  }
  filterItem(item){
    const { skuDataList = [], goodsData = {}, selectedValue } = this.state;
    const { skus = [] } = goodsData || {}
    let _selectedValue = JSON.parse(JSON.stringify(selectedValue))
    let lastModiefied = {}
    let index = _selectedValue.findIndex(e=>e.name == item.name) //修改的筛选项类型
    if(_selectedValue[index].value == '' || _selectedValue[index].value != item.value){
      _selectedValue[index].value = item.value
      lastModiefied = {name:item.name,value:item.value }
    }else{
      _selectedValue[index].value = ''
      lastModiefied = {name:item.name,value:'' }
    }
    let _skuDataList = [];
    // selectedValue[index].value != '' && _selectedValue[index].value == item.value
    if (skus && skus.length > 0) {
      const attr = skus[0].attr || []
      attr.map(item => {
        _skuDataList.push({ name: item.name, list:[] })
      })
      skus.map( sku => {
        sku.attr.map((item,index) => {
          if(lastModiefied.value == ''){
            _skuDataList[index].list.push({...item,image:sku.image})
          }else{
            if(lastModiefied.name == item.name){
              _skuDataList[index].list = this.state._skuDataList[index].list
            }else{
              if(sku.attr.findIndex(e=> e.value == lastModiefied.value)!= -1){
                _skuDataList[index].list.push({...item,image:sku.image})
              }
            }
          }
        })
      })
      this.setState({_skuDataList: JSON.parse(JSON.stringify(_skuDataList))})
    }
    this.setState({selectedValue:_selectedValue, lastModiefied}, () => {
      this.swiper && this.swiper.slideTo(0, 300, false)
      this.uploadClickTrack({
        id: 'skuSelect',
        biz: JSON.stringify({ selectedValue:_selectedValue })
      })
    })
    
  }
  renderBaseInfo(){
    const { goodsData = {} } = this.state;
    const { brandName = '',categoryName='',commissionRate='' } = goodsData || {}
    return <div className="top-service-container">
      <div className="title">
        基本信息
     </div>
      <div className="baseInfo">
        <div className="info-item">站外分类：{categoryName}</div>
        <div className="info-item">站外品牌：{brandName}</div>
        <div className="info-item">佣金：{commissionRate}</div>
      </div>
    </div>
  }
  renderService() {
    const { goodsData = {} } = this.state;
    const { service = '' } = goodsData || {}
    if (!service) return null;
    return <div className="top-service-container" style={{marginTop: 20}}>
      <div className="title">
        服务
     </div>
      <div className="content">
        {service}
      </div>
    </div>
  }
  renderTabView() {
    const { goodsData = {}, tabIndex = 0 } = this.state;
    const { baseProperties = {}, sizeInfo = {}, imageAndText = [] } = goodsData || {}
    const { list = [] } = baseProperties || []
    const { sizeTemplate } = sizeInfo || {}
    let titleList = [];
    if (list && list.length > 0) {
      titleList.push('商品参数')
    }
    if (imageAndText && imageAndText.length > 0) {
      let hasImage = false
      imageAndText.map((item, index) => {
        const { images = [] } = item
        if (images && images.length > 0) {
          hasImage = true
        }
      })
      if(hasImage){
        titleList.push('商详图片')
      }
    }
    if (sizeTemplate && sizeTemplate && sizeTemplate.list && sizeTemplate.list.length > 0) {
      titleList.push('尺码')
    }
    titleList.push('二维码查看')
    return <div className="top-tab-container">
      <div className="tab-container">
        {titleList.map((item, index) => {
          const isSelected = tabIndex == index
          return <div className={isSelected ? "tab-item-selected" : "tab-item"} key={index} onClick={() => {
            this.setState({ tabIndex: index })
            this.uploadClickTrack({
              id: 'tabSelect',
              biz: JSON.stringify({ tabIndex: index })
            })
          }}>
            <span>{item}</span>
          </div>
        })}
      </div>
      {this.renderTableOne(list, titleList[tabIndex])}
      {this.renderTableTwo(imageAndText, titleList[tabIndex])}
      {this.renderTableThree(sizeTemplate && sizeTemplate.list, titleList[tabIndex])}
      {this.renderTableFour( titleList[tabIndex])}
      {/* {titleList[tabIndex] == '商品参数' && this.renderTableOne(list)}
      {titleList[tabIndex] == '商详图片' && this.renderTableTwo(imageAndText)}
      {titleList[tabIndex] == '尺码' && this.renderTableThree(sizeTemplate && sizeTemplate.list)} */}
    </div>
  }
  renderTableOne(list = [], title) {
    if (!list || list.length == 0) return null;
    return <div className={title == '商品参数' ? "table-one show" : "table-one hide"}>
      {list.map((item, index) => {
        return <div className="line">
          <div className="title">{item.key}</div>
          <div className="value">{item.value}</div>
        </div>
      })}
    </div>
  }
  renderTableTwo(list = [], title) {
    if (!list || list.length == 0) return null;
    return <div className={title == '商详图片' ? "table-two show": "table-two hide"}>
      {list.map((item, index) => {
        const { images = [] } = item
        if (!images || images.length == 0) return null;
        const view = images.map((cItem, cIndex) => {
          if (!cItem.url) return null;
          const { width, height } = cItem
          return <img
            width="100%"
            threshold={500}
            height="auto"
            key={'p-' + index + 'c-' + cIndex}
            src={utils.formatImgUrl(cItem.url, this.props.webpSupport)}
            effect="opacity"
          />
        })
        return view
      })}
    </div>
  }
  renderTableThree(list = [], title) {
    if (!list || list.length == 0) return null;
    let sizeList = list[0].sizeValue.split(',') || []
    let contentList = []
    sizeList.map((item, index) => {
      let i = {}
      list && list.map((cItem, cIndex) => {
        i['v' + cIndex] = cItem.sizeValue.split(',')[index]
      })
      contentList.push(i)
    })
    return <div className={title == '尺码' ? "table-three show": "table-three hide"}>
      <div className="line">
        {list.map((item, index) => {
          return <div key={'key-' + index} className="title">{item.sizeKey}</div>
        })}
      </div>
      {contentList.map((item, index) => {
        let ls = Object.keys(item) || []
        return <div className="line" key={'value-' + index}>
          {ls && ls.map((cItem, cIndex) => {
            return <div className="value" key={'value-' + index + '-child' + cIndex}>{item[cItem]}</div>
          })}
        </div>
      })}
    </div>
  }
  renderTableFour(title){
    const { goodsData = {}} = this.state;
    const { url, mall } = goodsData || {}
    let _url = mall == '云mall' && url ? url : decodeURIComponent(this.url)
    return <div className={title == '二维码查看' ? "table-four show": "table-four hide"}>
    <QRCode value={_url} size={250} className="qrcode" level="H"/>
    {/* {this.renderBtnView()} */}
  </div>
  }

  renderBtnView(){
    return <div className="btn" onClick={()=>{
      window.parent.postMessage({
        type: 'show_right_float_view',
        url: decodeURIComponent(this.url),
      }, '*');
    }}>试试通用预览工具</div>
  }
  handleClick = async(listItem) => {
    if (listItem.href) {
      window.open(listItem.href, '_blank');
    } else if (listItem.fetch) {
      const res = await Request({
        url: listItem.fetch,
        method: "get",
      })
      if (res.data.status == 0) {
        utils.toast('请求成功');
      }
    }
    this.uploadClickTrack({
      id: 'channelClick',
      biz: JSON.stringify({ listItem })
    })
  }
  renderChannelList(){
    const { channelList = [] } = this.state;
    
    if (!channelList || channelList.length === 0) {
      return null;
    }

    const hasMultipleChannels = channelList.length > 1;

    return (
      <div className="channel-info-section">
        {channelList.map((item, index) => {
          if (!item || item.length === 0) return null;
          
          return (
            <div className="channel-list" key={'channel-list-' + index}>
              {item
                .filter(cItem => channelShowType.includes(cItem.title))
                .map((cItem, cIndex) => {
                  const { title = '', list = [], supplier_id } = cItem;
                  
                  if (!list || list.length === 0) return null;
                  
                  return (
                    <div className="channel" key={'channel-' + cIndex}>
                      <div className="channel-title">{title}:</div>
                      <div className="channel-content">
                        {list.map((listItem, listIndex) => {
                          return <div 
                          key={'channel-content-' + listIndex} 
                          onClick={() => this.handleClick(listItem)}
                          className={listItem.href || listItem.fetch ? 'clickable-item' : ''}
                          dangerouslySetInnerHTML={{ 
                            __html: listItem.html_value 
                          }}
                        />
                        })}
                      </div>
                      {hasMultipleChannels && title === '识货状态' && (
                        <div 
                          className="channel-switch-btn"
                          onClick={() => this.handleSwitchChannel(supplier_id)}
                        >
                          切换该渠道
                        </div>
                      )}
                    </div>
                  );
                })
              }
            </div>
          );
        })}
      </div>
    );
  }

  handleSwitchChannel = (supplier_id) => {
    this.supplier_id = supplier_id;
    this.getAttrData()
    this.uploadClickTrack({
      id: 'channelSwitch',
      biz: JSON.stringify({ supplier_id })
    })
  }

  render() {
    const { baseConfig } = this.props.config;
    const { NODATA, loading } = this.state;
    let _url = decodeURIComponent(this.url)
    return (
      <div
        className="pipeline-goodsInfoPreview"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        // style={{height:800,overflow:'auto'}}
      >
        {NODATA && <div className="no-data">
          <QRCode value={_url} size={250} className="qrcode" level="H"/>
          <div className="title">暂无数据，可使用手机扫描二维码访问</div>
          {/* {this.renderBtnView()} */}
          </div>}
        {!NODATA && 
        <div>
          {loading ?
            <div className="next-loading-fusion-reactor"><span className="next-loading-dot"></span><span className="next-loading-dot"></span><span className="next-loading-dot"></span><span className="next-loading-dot"></span></div>
          : 
          <div className="goods-info-parent">
            <div className="goods-item-left-list">
              {this.renderGoodsImgList()}
              <div className="goods-info-container">
                {this.renderChannelList()}
              </div>
            </div>
            <div className="goods-item-right-list">
              <div className="goods-info-container">
                {this.renderTitle()}
                {this.renderSKUNum()}
                {this.renderDescInfo()}
                {this.renderSKUListNew()}
                {this.renderBaseInfo()}
                {this.renderService()}
                {this.renderTabView()}
              </div>
            </div>
          </div>}
          
        </div>
        }
      </div>
    );
  }
}

PipelineGoodsInfoPreview.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineGoodsInfoPreview };
export default PipelineGoodsInfoPreview;



// WEBPACK FOOTER //
// ./components/pipeline-goodsInfoPreview/index.js